<template>
	<dashboard-panel
		title="Channels"
		:edit-mode="editMode"
		popout-url="/app/channelList.html"
		:popout-width="400"
		:popout-height="700"
		@remove="$emit('remove')"
	>
		<div class="h-100 d-flex flex-column overflow-hidden">
			<div class="flex-fill overflow-auto">
				<channel-list @updated="$emit('bottom-out')" @edit="$refs.channelModal.showEdit($event.service_id, $event.token)" @free-limit-changed="freeChannelLimitReached = $event" ref="channelList"></channel-list>
			</div>
			<div class="p-2 add-channel-container">
				<b-button class="w-100" variant="primary" @click="onAddChannel">
					Add channel
					<b-badge v-if="freeChannelLimitReached" variant="warning" class="ml-2">Upgrade<span class="add-channel-badge-extra"> for more than 3 channels</span></b-badge>
				</b-button>
			</div>
		</div>
		<channel-modal ref="channelModal" @saved="onChannelSaved"></channel-modal>
	</dashboard-panel>
</template>

<script>
import DashboardPanel from '../DashboardPanel.vue';
import ChannelList from '../ChannelList.vue';
import ChannelModal from '../Channel/Modal/ChannelModal';

export default {
	name: 'ChannelsPanel',
	components: { DashboardPanel, ChannelList, ChannelModal },
	props: {
		editMode: { type: Boolean, default: false },
		// Bumped by the parent to restart the channel poller (e.g. after scheduling).
		refreshToken: { type: Number, default: 0 },
		// The scheduled time to highlight in the channel list, set when a schedule is created.
		schedulingAt: { type: String, default: null },
	},
	data() { return {
		freeChannelLimitReached: false,
	}},
	watch: {
		refreshToken() { this.$refs.channelList?.channelPoller?.start(); },
		schedulingAt(at) { if(at) this.$refs.channelList?.markScheduling?.(at); },
	},
	methods: {
		onChannelSaved() {
			this.$refs.channelList?.channelPoller?.start();
			this.$emit('updated');
		},
		onAddChannel() {
			if(this.freeChannelLimitReached) this.$root.$emit('show-upgrade-modal', { message: 'Please upgrade for more than 3 active channels' });
			else this.$refs.channelModal.show();
		},
	},
};
</script>

<style scoped>
/* Container-queried, not window-queried: a panel can be narrow in a wide window. */
.add-channel-container {
	container-type: inline-size;
}

@container (max-width: 380px) {
	.add-channel-badge-extra {
		display: none;
	}
}
</style>
